import config from "../config";
import { createClient } from "@supabase/supabase-js";

if (!config.supabase.url || !config.supabase.apiKey) {
  throw new Error("Add env to supabase");
}

const supabase = createClient(config.supabase.url, config.supabase.apiKey);

export default supabase;
